import { DATA_DOWNLOADS_PATH, OIL_AND_GAS_MAP_PATH } from '../../../../utils/constants';

import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';
import React from 'react';
import RoomIcon from '@mui/icons-material/Room';
import { ShinyLink } from '../../../../components/Shiny';
import makeStyles from '@mui/styles/makeStyles';
import { useCurrentUser } from '../../../../contexts/CurrentUserContext';

const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.palette.button,
  },
}));

export default () => {
  const classes = useStyles();
  const { isUserEntitled } = useCurrentUser();

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={2} />
      <Grid container spacing={2} size={8}>
        <Grid>
          <Button
            component={Link}
            to={OIL_AND_GAS_MAP_PATH}
            variant="contained"
            className={classes.button}
            underline="none"
            disabled={!isUserEntitled(OIL_AND_GAS_MAP_PATH)}
          >
            <RoomIcon fontSize="small" />
            &nbsp;oil and gas map
          </Button>
        </Grid>
        <Grid>
          <ShinyLink
            startAdornment={<BubbleChartIcon fontSize="small" />}
            link={{ title: 'heat maps', page: 'map' }}
            styles={{ link: classes.button }}
            variant="contained"
            disabled={!isUserEntitled(DATA_DOWNLOADS_PATH)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
